(function($) {
    'use strict';
    $('.mod_newslist_filter').each(function() {
        let $form = $(this).find('form');
        $form.find('select').on('change', function() {
            $form.submit();
        });
    });
})(jQuery);
